module.exports = __webpack_public_path__ + "img/20_minutos_card.f60ea003.svg";